document.addEventListener("DOMContentLoaded", function () {
  const videoContainers = document.querySelectorAll(".video-container");
  let currentlyPlaying = null;

  // function to reset a video to its initial state
  function resetVideo(container) {
    if (!container) return;

    const video = container.querySelector(".review-video");
    const playButton = container.querySelector(".play-button");

    video.pause();
    video.controls = false;
    playButton.style.display = "flex";
  }

  videoContainers.forEach((container) => {
    const video = container.querySelector(".review-video");
    const playButton = container.querySelector(".play-button");

    playButton.addEventListener("click", function () {
      // if there's another video playing, reset it first
      if (currentlyPlaying && currentlyPlaying !== container) {
        resetVideo(currentlyPlaying);
      }

      currentlyPlaying = container;

      // For non-Safari browsers, use standard controls
      if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        // Add controls once the user clicks play
        video.controls = true;
      }

      // Hide the play button
      playButton.style.display = "none";
      // Play the video
      video.play();
    });

    video.addEventListener("click", function (e) {
      e.stopPropagation();
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    video.addEventListener("contextmenu", function (e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    video.addEventListener("keydown", function (e) {
      if (e.key === "f" || e.key === "F" || e.keyCode === 70) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });

    // show the play button again when the video ends
    video.addEventListener("ended", function () {
      resetVideo(container);
      currentlyPlaying = null;
    });
  });

  // reset all videos when user clicks elsewhere on the page
  document.addEventListener("click", function (event) {
    if (!event.target.closest(".video-container") && currentlyPlaying) {
      resetVideo(currentlyPlaying);
      currentlyPlaying = null;
    }
  });

  // Safari specific handling
  if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    videoContainers.forEach((container) => {
      const video = container.querySelector(".review-video");

      // Prevent default controls on Safari and use our own
      video.addEventListener("play", function () {
        // This removes the default controls after play starts
        setTimeout(() => {
          // Force controls attribute to false after a delay
          if (video.hasAttribute("controls")) {
            video.removeAttribute("controls");

            // Create custom controls if needed
            if (!container.querySelector(".custom-controls")) {
              const customControls = document.createElement("div");
              customControls.className = "custom-controls";

              // Play/Pause button
              const playPauseBtn = document.createElement("button");
              playPauseBtn.className = "custom-play-pause";
              playPauseBtn.innerHTML = "❚❚";
              playPauseBtn.addEventListener("click", function () {
                if (video.paused) {
                  video.play();
                  playPauseBtn.innerHTML = "❚❚";
                } else {
                  video.pause();
                  playPauseBtn.innerHTML = "▶";
                }
              });

              // Volume slider
              const volumeSlider = document.createElement("input");
              volumeSlider.type = "range";
              volumeSlider.min = 0;
              volumeSlider.max = 1;
              volumeSlider.step = 0.1;
              volumeSlider.value = video.volume;
              volumeSlider.className = "custom-volume";
              volumeSlider.addEventListener("input", function () {
                video.volume = this.value;
              });

              // Progress bar
              const progressBar = document.createElement("div");
              progressBar.className = "custom-progress-container";
              const progress = document.createElement("div");
              progress.className = "custom-progress";
              progressBar.appendChild(progress);

              video.addEventListener("timeupdate", function () {
                const percent = (video.currentTime / video.duration) * 100;
                progress.style.width = percent + "%";
              });

              progressBar.addEventListener("click", function (e) {
                const pos = (e.pageX - this.offsetLeft) / this.offsetWidth;
                video.currentTime = pos * video.duration;
              });

              // Add all controls to container
              customControls.appendChild(playPauseBtn);
              customControls.appendChild(progressBar);
              customControls.appendChild(volumeSlider);
              container.appendChild(customControls);
            }

            // Show custom controls
            container.querySelector(".custom-controls").style.display = "flex";
          }
        }, 100);
      });
    });
  }
});
